import { For, Show } from 'solid-js';
import { css } from 'styled-system/css';
import { Box } from 'styled-system/jsx';

interface Props {
  content: string;
  noPadding?: boolean;
}

/**
 * Regex explanation:
 * 1. Captures standard URLs to turn them into links.
 * 2. Specifically identifies TradingView 'x' links to extract the ID.
 */
const URL_REGEX = /(https?:\/\/[^\s]+)/g;
const TV_SNAPSHOT_REGEX = /https:\/\/www\.tradingview\.com\/x\/([a-zA-Z0-9]+)\/?/;

export const Content = (props: Props) => {
  // We split by the regex but keep the matches in the array
  const parts = () => props.content.split(URL_REGEX);

  return (
    <Box
      fontSize="sm"
      px={props.noPadding ? 0 : 2}
      py={props.noPadding ? 0 : 1}
      style={{ "white-space": "pre-wrap", "word-break": "break-word" }}
    >
      <For each={parts()}>
        {(part) => {
          const tvMatch = part.match(TV_SNAPSHOT_REGEX);

          if (URL_REGEX.test(part)) {
            return (
              <>
                <a
                  href={part}
                  target="_blank"
                  rel="noopener noreferrer"
                  class={css({ color: 'jade.10', _hover: { textDecoration: 'underline' } })}
                >
                  {part}
                </a>

                <Show when={tvMatch}>
                  <Box mt="3" mb="2" maxW="500px">
                    <a href={part} target="_blank" rel="noopener noreferrer">
                      <img
                        src={`https://www.tradingview.com/x/${tvMatch![1]}?png`}
                        alt="TradingView Chart"
                        class={css({
                          width: '100%',
                          height: 'auto',
                          borderRadius: 'md',
                          border: '1px solid',
                          borderColor: 'border.default',
                          transition: 'opacity 0.2s',
                          _hover: { opacity: 0.9 }
                        })}
                      />
                    </a>
                  </Box>
                </Show>
              </>
            );
          }

          // Return plain text segments
          return <span>{part}</span>;
        }}
      </For>
    </Box>
  );
};
